export const formatBytes = (bytes: number, decimals = 2) => {
	if (!+bytes) return '0 Bytes';

	const base = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB'];

	const size = Math.floor(Math.log(bytes) / Math.log(base));

	return `${parseFloat((bytes / base ** size).toFixed(dm))} ${sizes[size]}`;
};

export const downloadFile = (data: string, fileName: string) => {
	const url = window.URL.createObjectURL(new Blob([data]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', fileName);
	link.click();
	setTimeout(() => window.URL.revokeObjectURL(url), 0);
};
